



























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';

import VuetifySelectItems from '@/types/app/vuetifySelectItems';
import Customer from '@/types/customer/Customer';
import Endpoint from '@/utils/endpoint';
import CustomerService from '@/services/customerService';
import UserInterface from '@/types/app/IUser';
import auth from '@/store/modules/auth';
import { Watch } from 'vue-property-decorator';

const namespace = 'account';
@Component({
  data: () => ({
    required: (v: any) => !!v || 'This field is required'
  })
})
export default class ModalAccountMirror extends Vue {
  @Getter('getModalAccountMirrorState', { namespace:'customer' })
  modalAccountMirrorState!: boolean;
  @Getter('getUser', { namespace: 'auth' }) user!: UserInterface;
  @Action('setModalAccountMirrorState', { namespace:'customer' })
  setModalAccountMirrorState!: any;
  @Getter('getCustomers', { namespace:'customer' }) customers!: Customer[];
  @Action('setCustomers', { namespace:'customer' }) setCustomers!: any;
  @Getter('getLoading', { namespace }) loading!: boolean;

  @Action('setLoading', { namespace }) setLoading!: any;

  private endpoint = new Endpoint();

  customersWithAcount: VuetifySelectItems[] = [];
  customersOthers: VuetifySelectItems[] = [];
  customerService= new CustomerService(this.$http);
  mirrorUser = { userIdMirroring:'', userId: '' }
  selectedCustomers: any[] = [];
  accountLoading = false;
  currentMirror = { email: '', name: ''}
  
  errorCreate = false;
  errorMessage!: string;

  @Watch('modalAccountMirrorState')
  async loadingCustomers() {
    this.accountLoading = true;
    
   await Promise.all([
      this.getCustomers(),
      this.getMirrorAccount(),
    ]);    
    this.accountLoading = false;
  }

  private get form(): HTMLFormElement {
    return this.$refs.form as HTMLFormElement;
  }

  async makeMirrorAccount() {
    if (this.form.validate()) {
      this.accountLoading = true;

      try {
        const url = this.endpoint.mirrorAccount;
        this.mirrorUser.userId = this.user.id;
        this.errorCreate = false;
        this.$http
          .put(`${url}`, this.mirrorUser)
          .then((res: any) => {
            if(!res.hasErrors){
            this.clearFields();
            this.closeModal();
            }
            else {
              this.errorMessage = res.errors[0];
              this.errorCreate = true;
            }
          })
          .catch((err) => {
            console.error(err);
          });

        this.accountLoading = false;
      } catch (error) {
        console.error(error);
      }
    }
  }

  async deleteMirrorAccount(){
      this.accountLoading = true;

      try {
        const url = this.endpoint.mirrorAccount;
        this.errorCreate = false;
        this.$http
          .delete(`${url}`)
          .then((res: any) => {
            if(!res.hasErrors){
            this.clearFields();
            this.closeModal();
            }
            else {
              this.errorMessage = res.errors[0];
              this.errorCreate = true;
            }
          })
          .catch((err) => {
            console.error(err);
          });

        this.accountLoading = false;
      } catch (error) {
        console.error(error);
      }
    
  }

 
  async getMirrorAccount() {
      this.accountLoading = true;

      try {
        const url = this.endpoint.mirrorAccount;
        this.$http
          .get(`${url}`)
          .then((res: any) => {
            
              this.currentMirror.email = res.data;
                 
          })
          .catch((err) => {
            console.error(err);
          });

        this.accountLoading = false;
      } catch (error) {
        console.error(error);
      }
    
  }


  closeModal(): void {
    this.clearFields();
    this.setModalAccountMirrorState(false);
  }

  clearFields() {
    this.form.reset();
  }

  
  async getCustomers(): Promise<void> {
    
    const customerOrdened = [...this.customers];
    customerOrdened.sort((a,b) => a.fullName.localeCompare(b.fullName));
    
    const itemsForVuetifySelect =     
      customerOrdened.map((item) => {        
   
        return {
          text: `${item.fullName} - ${item.email}`,
          value: item.id,
          data: item,
        };
      });

      
    this.customersOthers = itemsForVuetifySelect.filter((x) => x.data.id != this.user.id);
  }
}
